import { env } from '~/env'

export default function getAppURL(appName: string) {
  const domain =
    env.VITE_BACKEND_MODE === 'development' ? 'dev.buffer.com' : 'buffer.com'
  return `https://${appName}.${domain}`
}
